import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../pages/LoderContext"; // confirm this path
import {
   ChevronRight
} from "lucide-react";
const JobsListing = ({ filteredJobs = [] }) => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const [initialLoadDone, setInitialLoadDone] = useState(false);

  useEffect(() => {
    showLoader();
    return () => hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!initialLoadDone && Array.isArray(filteredJobs)) {
      hideLoader();
      setInitialLoadDone(true);
    }
  }, [filteredJobs, initialLoadDone, hideLoader]);

  const approvedJobs = Array.isArray(filteredJobs)
    ? filteredJobs.filter(
        (job) => job?.approved === true || job?.status === "approved"
      )
    : [];

  const jobsToShow = approvedJobs.length > 0 ? approvedJobs : filteredJobs;

  if (!Array.isArray(filteredJobs)) return null;

  return (
    <div className="mb-12">
      {/* Heading Section */}
      {/* <div className="flex justify-between items-center mb-6 px-4 sm:px-6">
        <h1 className="text-2xl font-semibold text-gray-800">
          Latest Jobs Available in Delhi NCR
        </h1>
        <div className="text-sm text-gray-500">
          Updated on{" "}
          {new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>
      </div> */}


<div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 px-4 sm:px-6">
  {/* Heading */}
  <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
    Latest Jobs Available in Delhi NCR
  </h1>

  {/* Updated on Date */}
  <div className="text-sm text-gray-500 mt-2 sm:mt-0 text-right w-full sm:w-auto">
    Updated on{" "}
    {new Date().toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    })}
  </div>
</div>


      {/* Jobs Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {jobsToShow.map((job) => (
          <div
            key={job.id}
            className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
          >
            <div className="p-6 flex flex-col justify-between h-full">
              <div>
                {/* 🆕 Posted date on top */}
                <p className="text-sm text-gray-500 mb-2">
                  Posted on{" "}
                  {job.postedDate
                    ? new Date(job.postedDate).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                    : "N/A"}
                </p>

                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-xl font-semibold text-gray-800">
                    {job.title}
                  </h3>
                  <span className="bg-[#F5F5F5] text-red-600 text-sm px-3 py-1 rounded-full font-medium">
                    {job.location}
                  </span>
                </div>

                <div className="mb-4">
                  <p className="text-gray-600 font-medium">{job.company}</p>
                </div>

                <div className="mb-4">
                  <p className="text-sm text-gray-700">
                    <span className="font-medium">Skills required:</span>{" "}
                    {job.requirements}
                  </p>
                </div>
              </div>
<div className="flex justify-end mt-2">
              <button
                // className="w-full mt-4 bg-[#1e6c8e]      text-white py-2 rounded-lg hover:bg-[#1e6c8e] transition duration-300"
            className="px-5 sm:px-5 bg-[#1e6c8e] text-white py-2 rounded-lg 
               hover:bg-[#155a73] transition duration-300 w-auto"
                onClick={() =>
                  navigate(`/jobdetails/${job.id}`, { state: { job } })
                }
              >
                Apply Now
              </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* No Jobs Message */}
      {jobsToShow.length === 0 && (
        <div className="bg-white rounded-lg shadow-md p-8 text-center mt-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            No jobs found
          </h3>
          <p className="text-gray-600">
            Try changing the filters or check back later for new opportunities.
          </p>
        </div>
      )}
      <div className="flex justify-center mt-10">
  <button
    onClick={() => navigate("/findjobs")}
    className="inline-flex items-center px-6 py-3 text-white bg-red-600 hover:bg-red-600 rounded-lg shadow-md transition"
  >
    View All Jobs
    <ChevronRight className="ml-2 w-5 h-5" />
  </button>
</div>

    </div>
    

  );
};

export default JobsListing;
